<script setup lang="ts">
import { ref, onMounted, nextTick, onUnmounted } from "vue";
import { trans } from "laravel-vue-i18n";

const component = ref<HTMLDivElement>();

const emit = defineEmits(["submit", "back", "mounted"]);

onMounted(async () => {
    await nextTick();

    const updateHeight = () => {
        if (component.value) {
            const height = component.value.getBoundingClientRect().height;
            emit("mounted", height);
        }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
        updateHeight();
    });

    if (component.value) {
        resizeObserver.observe(component.value);
    }

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    // Clean up
    onUnmounted(() => {
        if (component.value) {
            resizeObserver.unobserve(component.value);
        }
        window.removeEventListener("resize", updateHeight);
        window.removeEventListener("orientationchange", updateHeight);
    });

    // scroll to top
    window.scrollTo(0, 0);
});
</script>

<template>
    <div ref="component" class="w-full px-4 pt-10 pb-4 md:p-10 lg:p-[3.75rem]">
        <button class="group mb-4 inline-flex items-center text-14 uppercase !leading-normal" @click="emit('back')">
            <span class="mr-2 rotate-180 transform transition-transform group-hover:-translate-x-1">
                <svg-vue icon="arrow" class="h-4 w-auto"></svg-vue>
            </span>
            Terug
        </button>
        <h3 class="mb-6 text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%] md:text-left">{{ trans("membership.period_title") }}</h3>
        <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
            <button class="group flex w-full flex-col" @click="emit('submit', 3)">
                <svg-vue icon="3_years" class="mb-4 h-auto w-full"></svg-vue>
                <div class="mb-4 flex w-full items-end justify-between">
                    <h3 class="text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%] md:text-left">3 jaar</h3>
                    <span class="pb-1">&euro; 000</span>
                </div>
                <span class="btn btn-black">Selecteer</span>
            </button>
            <button class="group flex w-full flex-col" @click="emit('submit', 6)">
                <svg-vue icon="6_years" class="mb-4 h-auto w-full"></svg-vue>
                <div class="mb-4 flex w-full items-end justify-between">
                    <h3 class="text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%] md:text-left">6 jaar</h3>
                    <span class="pb-1">&euro; 000</span>
                </div>
                <span class="btn btn-black">Selecteer</span>
            </button>
            <button class="group flex w-full flex-col" @click="emit('submit', 9)">
                <svg-vue icon="9_years" class="mb-4 h-auto w-full"></svg-vue>
                <div class="mb-4 flex w-full items-end justify-between">
                    <h3 class="text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%] md:text-left">9 jaar</h3>
                    <span class="pb-1">&euro; 000</span>
                </div>
                <span class="btn btn-black">Selecteer</span>
            </button>
        </div>
    </div>
</template>
